import {createWithIntlProvider} from '@kne/react-intl';
import zhCN from './locale/zh-CN';
import enUS from './locale/en-US';

const withLocale = createWithIntlProvider({
    defaultLocale: 'zh-CN', messages: {
        'zh-CN': zhCN, 'en-US': enUS
    }, namespace: 'FormInfo'
});

export default withLocale;
